import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import createLazyComponent from '@src/utils/create-lazy-component';
import Page from '@src/components/page';
import PageSwiper from '@src/components/swiper/page-swiper';
import ScrollTip from '@src/business-components/scroll-tip';
import ComponentFooter from '@src/business-components/common-footer';
import MainStore from './store';
import FirstPage from './components/first-page';

const styles = require('./index.less');

const ThirdPageLazy = createLazyComponent(() => import('@src/pages/main/components/third-page'));
const FourthPageLazy = createLazyComponent(() => import('@src/pages/main/components/fourth-page'));
const FifthPageLazy = createLazyComponent(() => import('@src/pages/main/components/fifth-page'));
const SixthPageLazy = createLazyComponent(() => import('@src/pages/main/components/sixth-page'));
const SeventhPageLazy = createLazyComponent(() => import('@src/pages/main/components/seventh-page'));
const EighthPageLazy = createLazyComponent(() => import('@src/pages/main/components/eighth-page'));

/**
 * Main
 * @param store {MainStore}
 * @returns {JSX.Element}
 * @constructor
 */
const Main = ({ store }) => {
  const { pageSwiperStore } = store;
  store.use();

  return (
    <Page className={cx(styles.root, 'main-page-root', 'page-main')}>
      <PageSwiper store={store.pageSwiperStore}>
        <div className={styles.pageItem}>
          <FirstPage store={store.firstPageStore} />
        </div>
        <div className={styles.pageItem}>{<ThirdPageLazy store={store.newsStore} />}</div>
        <div className={styles.pageItem}>{<FourthPageLazy store={store.mechaListStore} />}</div>
        <div className={styles.pageItem}>
          <FifthPageLazy store={store.specialMechaStore} />
        </div>
        <div className={styles.pageItem}>{<SixthPageLazy store={store.featureListStore} />}</div>
        <div className={styles.pageItem}>{<SeventhPageLazy store={store.worldViewStore} />}</div>
        <div className={styles.pageItem}>{<EighthPageLazy />}</div>
      </PageSwiper>

      <ComponentFooter store={store.comFooterStore} />
      <ScrollTip store={store.scrollTipStore} />
    </Page>
  );
};

export default wrapStore(Main, MainStore);
